import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { DocumentVerificationList } from '@app/_models/DocumentVerificationList';
import { catchError, map, retry } from 'rxjs/operators';
import { headervalue } from 'src/headervalue/header';
import { statusRemark } from '@app/_models/statusRemark';
import { Observable } from 'rxjs';

const httpOptions = {
  // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })

export class DocumentVerificationListService {
  url: string;
  constructor(private http: HttpClient) { }

  getDocumentVerificationList() {
    // return this.http.get<DocumentVerificationList[]>(`${environment.apiUrl}/verifier/getVerifierRequestList`);
    var userId = localStorage.getItem('user_id');
    var temp = this.http.get<any>(`${environment.apiUrl}/verifier/getVerifierRequestList/`  + userId , httpOptions);
    return temp;
  }

  getOverallSummary(year){
    return this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getRequestStatusSummaryByYear/`+year)
  }

  getAgeingSummary(year){
    return this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getAgeingSummaryByYear/`+year)
  }

  getVerificationRejectList(){
    return this.http.get<any>(`${environment.apiUrl}/verifier/getRejectedRequests`)
  }

  getRejectionReason(id){
    return this.http.get<any>(`${environment.apiUrl}/verifier/getRejectionTrailById/`+id, httpOptions)
  }

  getverifydocumentImage(path) {
    // var temp = this.http.get<any>(path, { headers: new HttpHeaders(headervalue.headerWithJwt), responseType: 'blob' } );
    // return temp;
    // responseType: 'blob' as 'json' 
    // 'responseType'  : 'arraybuffer' as 'json'
    var v = this.http.get<Blob>(path, { headers: new HttpHeaders(headervalue.headerWithJwt), responseType: 'blob' as 'json' });
    return v;
  }

  getDocument(id) {
    // var temp = this.http.get<any>(path, { headers: new HttpHeaders(headervalue.headerWithJwt), responseType: 'blob' } );
    // return temp;
    // responseType: 'blob' as 'json' 
    // 'responseType'  : 'arraybuffer' as 'json'
    var v = this.http.get<Blob>(`${environment.apiUrl}/verifier/getimage/VR/`+id, { headers: new HttpHeaders(headervalue.headerWithJwt), responseType: 'blob' as 'json' });
    return v;
  }

  getverifydocument(id) {
    var temp = this.http.get<any>(`${environment.apiUrl}/verifier/getverifydocument/` + id, httpOptions);
    return temp;
  }

  // setStatus(id, status, userid) {
  //   var temp = this.http.post<any>(`${environment.apiUrl}/verifier/setStatusForVerifierDocument/` + id + `/` + status + `/` + userid, '', { headers: new HttpHeaders(headervalue.headerWithJwt) });
  //   return temp;
  // }
  setStatus(statusRemarkParam: statusRemark): Observable<statusRemark> {
    return this.http.post<statusRemark>(`${environment.apiUrl}/verifier/setStatusForVerifierDocument`, statusRemarkParam, httpOptions).pipe();
  }
  setStatusUniversity(statusRemarkParam: statusRemark): Observable<statusRemark> {
    return this.http.post<statusRemark>(`${environment.apiUrl}/universityVerifier/setStatusForUniversityDocument`, statusRemarkParam, httpOptions).pipe();
  }

  // setStatusSV(id, status) {

  //   var temp = this.http.post<any>(`${environment.apiUrl}/superVerifier/setStatusForSuperVerifierDocument/` + id + `/` + status, '', { headers: new HttpHeaders(headervalue.headerWithJwt) });
  //   return temp;
  // }

  setStatusSV(statusRemarkParam: statusRemark): Observable<statusRemark> {
    return this.http.post<statusRemark>(`${environment.apiUrl}/superVerifier/setStatusForSuperVerifierDocument`, statusRemarkParam, httpOptions).pipe();
  }

  getPDF(statusRemarkParam: statusRemark): Observable<Blob> {
    const url = `${environment.apiUrl}/student/generateVerificationPdf`;
  
    return this.http.post<Blob>(url, statusRemarkParam, {
      headers: headervalue.headerWithJwt,
      responseType: 'blob' as 'json'
    });
  }




}